export default __webpack_public_path__ + "static/media/webinar.be6fa168.png";